import * as Redux from 'redux'
import * as Constants from './constants'
import * as Types from './types'

export const selectCommunity = (communityIdentifier: Types.CommunityIdentifier) =>
  ({type: Constants.SELECT_COMMUNITY, communityIdentifier})
export const mediaQuerySet = (window: any) =>
  ({type: Constants.MEDIA_QUERY_SET, window})
export type UrlParsedAction<Params = {}> = Redux.Action & {params: Params}
export type UrlParsedActionCreator = (params: {}) => UrlParsedAction
export const urlParsed: UrlParsedActionCreator = (params) =>
  ({type: Constants.URL_PARSED, params})
export const searchParamsUpdated = (field: {}) => ({type: Constants.UPDATED, field})
export const updateUrlParams = (params: {}) => ({type: Constants.UPDATE_URL_PARAMS, params})



// WEBPACK FOOTER //
// ./src/app/actions.ts